(function () {
  var timer = document.getElementById('CountdownTimer');
  if (!timer) return;

  var rawDate = timer.dataset.date;
  if (!rawDate) return;

  var targetDate = new Date(rawDate + 'T00:00:00').getTime();

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var diff = targetDate - Date.now();

    if (diff <= 0) {
      setValues('00', '00', '00', '00');
      return;
    }

    var days    = Math.floor(diff / 86400000);
    var hours   = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    setValues(pad(days), pad(hours), pad(minutes), pad(seconds));
  }

  function setValues(d, h, m, s) {
    document.getElementById('countdown-days').textContent    = d;
    document.getElementById('countdown-hours').textContent   = h;
    document.getElementById('countdown-minutes').textContent = m;
    document.getElementById('countdown-seconds').textContent = s;
  }

  tick();
  setInterval(tick, 1000);
})();
